export default {

    inserted (el, binding) {
        const target_selector = (binding.value && binding.value.filter) ? binding.value.filter : 'a'

        $(el).find(target_selector)
          .featherlightGallery({
              type: 'image',
              closeIcon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><polygon points="499.8,71.4 441.5,13 256,198.2 73.2,15.2 14.8,73.5 197.5,256.6 12,441.8 70.3,500.3 255.9,315 438.6,498.1 497.1,439.7 314.3,256.7 "/></svg>',
              previousIcon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 290.6 512"><path d="M245 507.9L7.9 256.4 245 4.9l41.3 38.9L85.9 256.4 286.3 469z"/></svg>',
              nextIcon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 290.6 512"><path d="M48.1 507.9L6.8 469l200.4-212.6L6.8 43.8 48.1 4.9l237.1 251.5z"/></svg>',
              galleryFadeIn: 0,
              galleryFadeOut: 0,
              beforeContent: function(){
                // preload all images by inserting them into the DOM
                for (var i = 0; i < this.$source.length; i++) {
                  $('<img src="' + this.$source.eq(i).attr('href') + '">').appendTo('body').hide();
                }
              }
          })
    },

}
